import { CSSProperties } from "react";
import { GroupBase, GroupProps, OptionProps, StylesConfig } from "react-select";
import { components } from "react-select";

import CheckIcon from "@assets/icons/check.svg";

import { APP_COLORS } from "@styles/colors";
import { ICompanyType } from "@interfaces/company.interface";
import { Select, SelectProps } from "@ui/Select";
import { getCustomSelectStyles } from "@ui/Select";

export interface ICompanyTypeSelectOption extends ICompanyType {
  value: string;
  label: string;
  isDisabled?: boolean;
  disabledMessage?: string;
  isMessage?: boolean;
  is_enabled?: boolean;
}

const Option = (
  props: JSX.IntrinsicAttributes &
    OptionProps<ICompanyTypeSelectOption, false, GroupBase<ICompanyTypeSelectOption>>
) => {
  const { isMessage } = props.data;
  const { isSelected } = props;

  if (isMessage) {
    return (
      <div className="px-3 py-2">
        <div className="rounded-lg border border-stroke-primary bg-background-secondary p-2 text-xs font-normal text-content-secondary">
          {props.children}
        </div>
      </div>
    );
  }

  return (
    <components.Option {...props}>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {props.children}
        {isSelected && <CheckIcon width={20} height={20} color="#406A68" />}
      </span>
    </components.Option>
  );
};

export function CompanyTypeSelect({ ...rest }: SelectProps<ICompanyTypeSelectOption, false>) {
  const Group = (props: GroupProps<ICompanyTypeSelectOption, false>) => {
    const {
      Heading,
      getStyles,
      getClassNames,
      children,
      label,
      headingProps,
      cx,
      theme,
      selectProps,
    } = props;
    const lastOption = rest?.options?.[rest.options.length - 1];
    const isLastOption = props.label === lastOption?.label;

    const isGroupDisabled = props.data && "isDisabled" in props.data && !!props.data.isDisabled;
    const disabledMessage =
      props.data &&
      "disabledMessage" in props.data &&
      (props.data.disabledMessage?.toString() || "");

    return (
      <div
        aria-label={label as string}
        style={{
          ...(getStyles("group", props) as CSSProperties),
          padding: "0",
          borderColor: APP_COLORS.gray["200"],
          borderBottomWidth: isLastOption ? 0 : 1,
        }}
      >
        <Heading
          selectProps={selectProps}
          theme={theme}
          getStyles={getStyles}
          getClassNames={getClassNames}
          cx={cx}
          {...headingProps}
        >
          {isGroupDisabled && (
            <div className="-mx-2 mt-1 rounded-lg border border-stroke-primary bg-background-secondary p-2 text-xs font-normal normal-case text-content-secondary">
              {disabledMessage}
            </div>
          )}
        </Heading>
        <div>{children}</div>
      </div>
    );
  };

  return (
    <Select<ICompanyTypeSelectOption, false>
      {...rest}
      isMulti={false}
      isSearchable={false}
      menuPosition="absolute"
      styles={getCustomSelectStyles()}
      components={{ Group, Option, ...(rest.components || {}) }}
    />
  );
}
